var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrossCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  d: "M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4",
  "data-filled": "true"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4m0 37.4c-9.59 0-17.4-7.81-17.4-17.4S14.41 6.6 24 6.6 41.4 14.41 41.4 24 33.59 41.4 24 41.4",
  clipRule: "evenodd",
  "data-filled": "false"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-accent-fill, var(--thc-icon-accent-fill-default, white))",
  fillRule: "evenodd",
  d: "M32.99 15.03a1.3 1.3 0 0 0-1.84 0l-7.16 7.16-7.16-7.16a1.3 1.3 0 0 0-1.84 0 1.3 1.3 0 0 0 0 1.84l7.16 7.16-7.16 7.16a1.3 1.3 0 0 0 .92 2.22c.33 0 .67-.13.92-.38l7.16-7.16 7.14 7.14a1.31 1.31 0 0 0 1.84 0 1.3 1.3 0 0 0 0-1.84l-7.14-7.14 7.16-7.16a1.3 1.3 0 0 0 0-1.84",
  clipRule: "evenodd"
})));
export { SvgCrossCircle as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/cross-circle.svg", import.meta.url).toString();